import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getReportShippingCostAuditSlice = createSlice({
    name: "getReportShippingCostAudit",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getReportShippingCostAuditSlice_actions = getReportShippingCostAuditSlice.actions;
export var fetchData = _getReportShippingCostAuditSlice_actions.fetchData, fetchDataSuccess = _getReportShippingCostAuditSlice_actions.fetchDataSuccess, fetchDataFailure = _getReportShippingCostAuditSlice_actions.fetchDataFailure, resetState = _getReportShippingCostAuditSlice_actions.resetState;
export default getReportShippingCostAuditSlice.reducer;
